import * as T from '@effect-ts/core/Effect'
import { pipe } from '@effect-ts/core/Function'
import * as MO from '@effect-ts/morphic'
import { decode } from '@effect-ts/morphic/Decoder'
import Axios from 'axios'

const axios = Axios.create({
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
})

export const GetType = <E, A,>(type: MO.M<{}, E, A>) =>
  (url: string) =>
    pipe(
      T.tryCatchPromise(() =>
        axios
          .get(url), e => JSON.stringify(e)),
      T.map(r => r.data),
      T.chain(decodeWith(type)),
      T.mapError(JSON.stringify)
    )

const decodeWith = <E, A,>(type: MO.M<{}, E, A>) => decode(type)
